var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenIconGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 17V8L13 12.2857L8 17Z",
    fill: "#00B2A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 17V8L18 12.2857L13 17Z",
    fill: "#00B2A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenIconGreen);
export default __webpack_public_path__ + "static/media/open-icon-green.6d93f6fc85c41b7d0cf575335b8cb79a.svg";
export { ForwardRef as ReactComponent };